import {
  Autocomplete,
  Badge,
  Box,
  Chip,
  CircularProgress,
  createSvgIcon,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Skeleton,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
  Button,
} from "@mui/material";

import {
  Clear,
  Delete,
  Launch,
  MoreVert,
  NotInterestedOutlined,
  OpenInNewOutlined,
  Person,
  Search,
  SettingsOutlined,
  Settings,
  SettingsEthernet,
  DnsRounded,
  RouterRounded,
  ArrowDropDownOutlined,
  LocalOfferOutlined,
} from "@mui/icons-material";
import { alpha } from "@mui/system";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EasyFlow } from "../../../assets/icons/IconEasyFlow.svg";
import ModalEditCadastro from "../../../components/modalEditCadastro";
import useStyles from "./styles";

import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";

import DatagridComponent from "../../../components/datagridComponent";
import api from "../../../services/api";
import TagsMenu from "../../../components/tickets/tagsMenu";
import GrupoChip from "../../../components/grupoEconomico/GrupoChip";
import TipoClienteChip from "../../../components/tipoCliente/TipoClienteChip";
import ErpChip from "../../../components/erp/ErpChip";

const EasyFlowIcon = createSvgIcon(<EasyFlow />);

export default function Home({
  setRows = () => {},
  setSnackbar = () => {},
  setSelectedCliente = () => {},
  setBuscarUsuario = () => {},
  versaoClientes = 0,
  buscarUsuario = "",
  selectedTagFilter,
  setSelectedTagFilter,
  availableTags,
  setAvailableTags,
  handleNavigateFromHome = () => {},
  statusFilter = "todos",
  setStatusFilter = () => {},
  tipoClienteFilter = null,
  erpFilter = null,
}) {
  // const [buscarUsuario, setBuscarUsuario] = useState("");
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  const [anchorNotificacao, setAnchorNotificacao] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDesativacao, setOPenDesativacao] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [statusCliente, setStatusCLiente] = useState(null);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [pendentes, setPendentes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const [pagina, setPagina] = useState(0);
  const [linhasPorPagina, setLinhasPorPagina] = useState(100);
  const [ordenacao, setOrdenacao] = useState({ coluna: null, direcao: "asc" });
  const [linhas, setLinhas] = useState([]);
  const [total, setTotal] = useState(0);
  const [totais, setTotais] = useState({
    totalServicos: 0,
    totalHostsConfig: 0,
    totalCircuitosFilled: 0,
  });
  const [carregando, setCarregando] = useState(false);
  const [buscaAplicada, setBuscaAplicada] = useState(() => buscarUsuario.trim());
  const controllerRef = useRef(null);

  useEffect(() => {
    const temporizador = setTimeout(
      () => setBuscaAplicada(buscarUsuario.trim()),
      400,
    );
    return () => clearTimeout(temporizador);
  }, [buscarUsuario]);

  const filtrosAtuais = useMemo(
    () => ({
      busca: buscaAplicada || undefined,
      tagId: selectedTagFilter?.id || undefined,
      tipoCliente: tipoClienteFilter ?? undefined,
      erpId: erpFilter || undefined,
      preenchimento: statusFilter !== "todos" ? statusFilter : undefined,
    }),
    [
      buscaAplicada,
      selectedTagFilter?.id,
      tipoClienteFilter,
      erpFilter,
      statusFilter,
    ],
  );

  useEffect(() => {
    setPagina(0);
  }, [filtrosAtuais]);

  const buscarPagina = useCallback(async () => {
    controllerRef.current?.abort();
    const controller = new AbortController();
    controllerRef.current = controller;
    setCarregando(true);

    try {
      const resposta = await api.post(
        "/interno/find/clientesPaginado",
        {
          ...filtrosAtuais,
          pagina,
          tamanho: linhasPorPagina,
          ordenarPor: ordenacao.coluna || undefined,
          direcao: ordenacao.coluna ? ordenacao.direcao : undefined,
        },
        { signal: controller.signal },
      );
      setLinhas(resposta?.data?.clientes || []);
      setTotal(resposta?.data?.total || 0);
      if (resposta?.data?.totais) setTotais(resposta.data.totais);
    } catch (error) {
      if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") {
        return;
      }
      console.error(error);
    } finally {
      if (controllerRef.current === controller) setCarregando(false);
    }
  }, [filtrosAtuais, pagina, linhasPorPagina, ordenacao]);

  useEffect(() => {
    buscarPagina();
  }, [buscarPagina, versaoClientes]);

  useEffect(() => () => controllerRef.current?.abort(), []);

  const modeloOrdenacao = useMemo(
    () =>
      ordenacao.coluna
        ? [{ field: ordenacao.coluna, sort: ordenacao.direcao }]
        : [],
    [ordenacao],
  );

  const getClientFillingStatus = (row) => {
    const st = row?.ClienteConfigStatus;
    const totalServicos = st?.totalServicos || 0;
    const configCount = st?.totalHostsConfig || 0;
    const circuitCount = st?.totalCircuitosFilled || 0;

    const calcPercent = (count) => {
      if (!st) return 0;
      if (totalServicos > 0) {
        return Math.min(100, Math.round((count / totalServicos) * 100));
      }
      return count > 0 ? 100 : 0;
    };

    return {
      configFilled: configCount > 0,
      configFilledCount: configCount,
      configPercent: calcPercent(configCount),
      circuitFilled: circuitCount > 0,
      circuitFilledCount: circuitCount,
      circuitPercent: calcPercent(circuitCount),
      totalServicos,
    };
  };
  const open = Boolean(anchorEl);
  const openNotificacao = Boolean(anchorNotificacao);
  const logs = JSON.parse(localStorage.getItem("logs"));
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";

  const [tagsMenuAnchorEl, setTagsMenuAnchorEl] = useState(null);
  const [selectedClienteForTags, setSelectedClienteForTags] = useState(null);
  const [loadingTagClienteId, setLoadingTagClienteId] = useState(null);

  // New states for tags filter and bulk actions
  const [selectedClientIds, setSelectedClientIds] = useState([]);
  const [bulkTagMenuAnchorEl, setBulkTagMenuAnchorEl] = useState(null);

  const handleBulkTagAssign = async (tag) => {
    try {
      await api.post("/interno/bulk/addTagClientes", {
        tagId: tag.id,
        clienteIds: selectedClientIds,
      });
      setSnackbar({ children: "Tag atribuída aos clientes com sucesso!", severity: "success" });
      setSelectedClientIds([]);
      setBulkTagMenuAnchorEl(null);
      handleTagsSaved();
    } catch (error) {
      setSnackbar({ children: "Erro ao atribuir tag", severity: "error" });
    }
  };

  const handleOpenTagsDialog = (cliente, e) => {
    e.stopPropagation();
    setSelectedClienteForTags(cliente);
    setTagsMenuAnchorEl(e.currentTarget);
  };

  const handleTagsSaved = async () => {
    try {
      buscarPagina();

      if (typeof setAvailableTags === "function") {
        const tagsRes = await api.post("/interno/findMany/tagsCircuito", { type: "clienteGrupo" });
        setAvailableTags(tagsRes.data || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // conteudo a ser passado para o modal delete
  // tipos de modal detele 1: error, 2: warn, 3: info, 4: success
  const deleteBody =
    "Se você prosseguir com a operação, o item e todas as informações associadas serão excluídas permanentemente!";
  const confirmDelete = "Excluir";
  const confirmDesativar = "Desativar";
  const desativarBody =
    "Se você prosseguir com a operação, o cliente e seus usuários serão desativados.";

  function removeRow(id) {
    setRows((prev) => prev.filter((row) => row.id !== id));
    buscarPagina();
  }
  async function handleApiDeleteClientes(id) {
    setDeleteLoad(true);

    try {
      await api.delete("/cliente/dashHome/deleteClient", {
        data: {
          id: id,
          usuarioId: logs?.usuarioId,
          logsLoginId: logs?.id,
        },
      });

      setSnackbar({
        children: "Cliente deletado com sucesso!",
        severity: "success",
      });

      setAnchorEl(null);
      removeRow(id);
      setOpenDeleteModal(false);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setDeleteLoad(false);
    }
  }

  async function updateStatusCliente(clienteId, status) {
    try {
      const response = await api.post("/update/status/cliente", {
        clienteId,
        status,
      });

      setRows((prev) =>
        prev.map((cliente) =>
          cliente?.id === response?.data?.id
            ? { ...cliente, status: response?.data?.status }
            : cliente,
        ),
      );
      buscarPagina();
    } catch (error) {
      console.error(error);
    } finally {
      setStatusCLiente(null);
      setOPenDesativacao(false);
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (selectedRow) => {
    setAnchorEl(null);
    setAnchorNotificacao(null);
    setPendentes([]);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  function handleUpdatedClient(upDatedClient) {
    setRows((prev) =>
      prev.map((objeto) =>
        objeto.id === upDatedClient.id ? upDatedClient : objeto,
      ),
    );
    buscarPagina();
  }

  const linkView = (params) => {
    return (
      <Box sx={styles.launchContainer}>
        <Launch
          size="small"
          sx={styles.launchIcon}
          onClick={() => {
            localStorage.setItem("selectedClient", JSON.stringify(params?.row));
            // Substitua o navigate antigo por:
            handleNavigateFromHome(params?.row);
          }}
        />
      </Box>
    );
  };



  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    { field: "clienteErpId", headerName: "Código do Cliente", width: 100 },
    {
      field: "tipoCliente",
      headerName: "Tipo",
      width: 90,
      renderCell: (params) => {
        // A linha do grupo econômico é um cliente virtual, sem CNPJ e sem
        // contraparte no ERP — o tipoCliente dela é só o default da coluna e
        // rotulá-la como PJ seria inventar informação.
        if (params?.row?.isGrupoEconomico) return null;
        return <TipoClienteChip cliente={params?.row} />;
      },
    },
    {
      // ERP de origem do cliente. Grupo econômico não tem ERP (fica vazio).
      field: "erp",
      headerName: "ERP",
      width: 90,
      renderCell: (params) => <ErpChip erp={params?.row?.erp} />,
    },
    {
      field: "nome",
      headerName: "Clientes",
      flex: 1.2,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.75,
              width: "100%",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="body2"
              noWrap // 1. Impede a quebra de linha nativamente no Typography
              sx={{
                cursor: "pointer",
                display: "block", // 2. Garante que o componente se comporte como bloco para calcular a largura
                overflow: "hidden",
                textOverflow: "ellipsis", // 4. Adiciona os 3 pontinhos
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => {
                const clientStorage = {
                  interfaceId: "",
                  clienteId: params?.row?.id,
                  hostId: "",
                  selectTime: 5,
                  initialDate: "",
                  finalDate: "",
                };
                localStorage.setItem(
                  "filterData",
                  JSON.stringify(clientStorage),
                );
                handleNavigateFromHome(params?.row);
              }}
            >
              {params?.row?.nome || ""}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "grupoEconomicoNome",
      headerName: "Grupo Econômico",
      flex: 1.2,
      renderCell: (params) => {
        // Linha do próprio grupo: chip "Grupo" + quantidade de membros
        if (params?.row?.isGrupoEconomico) {
          const total = params?.row?.membros?.length || 0;
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
              <GrupoChip />
              <Typography variant="body2">
                {`${total} cliente${total === 1 ? "" : "s"}`}
              </Typography>
            </Box>
          );
        }
        if (!params?.row?.grupoEconomicoNome) return "";
        return (
          <GrupoChip
            label={params.row.grupoEconomicoNome}
            variant="owner"
          />
        );
      },
    },
    {
      field: "tagsCliente",
      headerName: "Tags",
      flex: 1.5,
      minWidth: 220,
      sortable: false,
      renderCell: (params) => {
        const tags = params.value || [];
        const cliente = params.row;

        const visibleTags = tags.slice(0, 3);
        const hiddenTags = tags.slice(3);

        return (
          <Button
            size="small"
            onClick={(event) => handleOpenTagsDialog(cliente, event)}
            sx={{
              ...styles.buttonGrupo,
              justifyContent: "flex-start",
              height: "auto",
              minHeight: "38px",
              py: 0.5,
              px: 0.5,
              maxWidth: "100%",
            }}
            variant="text"
            endIcon={<ArrowDropDownOutlined sx={{ fontSize: 18 }} />}
          >
            <Box sx={styles.tagsContainer}>
              {loadingTagClienteId === cliente.id ? (
                <Box sx={{ display: "flex", width: "100%", justifyContent: "center", py: 0.5 }}>
                  <CircularProgress size={20} />
                </Box>
              ) : tags.length > 0 ? (
                <>
                  {visibleTags.map((tag, i) => (
                    <Chip
                      key={tag.id || i}
                      size="small"
                      label={tag.tagName}
                      sx={{
                        ...styles.tagChipVisible,
                        bgcolor: tag.color,
                      }}
                    />
                  ))}
                  {hiddenTags.length > 0 && (
                    <Tooltip
                      arrow
                      placement="top"
                      title={
                        <Box sx={{ p: 0.5 }}>
                          <ul style={{ margin: 0, paddingLeft: "14px", listStyleType: "disc" }}>
                            {hiddenTags.map((g) => (
                              <li key={g.id} style={{ fontSize: "0.75rem", marginBottom: "2px" }}>
                                {g.tagName}
                              </li>
                            ))}
                          </ul>
                        </Box>
                      }
                    >
                      <Chip
                        size="small"
                        label={`+${hiddenTags.length}`}
                        sx={styles.tagCounterChip}
                      />
                    </Tooltip>
                  )}
                </>
              ) : (
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    ...styles.textNoGrupo,
                    fontSize: "0.63rem",
                  }}
                >
                  Adicione ou crie uma tag
                </Typography>
              )}
            </Box>
          </Button>
        );
      },
    },
    {
      field: "grupos",
      headerName: "Grupos",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const grupos = params.value || [];
        if (grupos.length === 0) return "-";

        const firstGrupo = grupos[0];
        const outrosGrupos = grupos.slice(1);

        return (
          <Box sx={styles.boxGrupoCliente}>
            <Chip
              label={firstGrupo?.grupoName}
              size="small"
              sx={{
                ...styles.chipGrupoCliente,
                backgroundColor: firstGrupo?.colorGrupo,
              }}
            />

            {grupos.length > 1 && (
              <Tooltip
                arrow
                placement="top"
                title={
                  <Box sx={{ p: 0.5 }}>
                    <ul
                      style={{
                        margin: 0,
                        paddingLeft: "14px",
                        listStyleType: "disc",
                      }}
                    >
                      {outrosGrupos.map((g) => (
                        <li
                          key={g.id}
                          style={{ fontSize: "0.75rem", marginBottom: "2px" }}
                        >
                          {g.grupoName}
                        </li>
                      ))}
                    </ul>
                  </Box>
                }
              >
                <Chip
                  label={`+${grupos.length - 1}`}
                  size="small"
                  sx={styles.chipOthers}
                />
              </Tooltip>
            )}
          </Box>
        );
      },
    },

    {
      field: "status",
      headerName: "Status cliente",
      flex: 0.6,

      renderCell: (params) => {
        const thisRow = params.row;
        return (
          <Chip
            label={thisRow.status === 0 ? "Ativo" : "Desativado"}
            sx={{
              bgcolor:
                thisRow.status === 0
                  ? "chip.main.completed"
                  : "chip.main.pending",
              width: "100px",
              height: "20px",
              color: theme.palette.white.main,
              fontWeight: 600,
            }}
            size="small"
          />
        );
      },
      valueGetter: (params) => {
        return params * -1;
      },
    },

    {
      field: "fillingStatusConfig",
      headerName: "Hosts",
      flex: 0.4,
      sortable: false,
      valueGetter: (value, row) => {
        const clientStatus = getClientFillingStatus(row);
        return clientStatus?.configPercent || 0;
      },
      renderCell: (params) => {
        // Status de preenchimento não se aplica a grupos econômicos
        if (params?.row?.isGrupoEconomico) return "—";

        const clientStatus = getClientFillingStatus(params.row);

        const configCount = clientStatus?.configFilledCount || 0;
        const configPercent = clientStatus?.configPercent || 0;
        const configTotal = clientStatus.totalServicos || configCount;
        
        let configIconColor = theme.palette.error.main;
        if (configPercent === 100) configIconColor = theme.palette.success.main;
        else if (configPercent >= 50) configIconColor = theme.palette.info.main;
        else if (configPercent > 0) configIconColor = theme.palette.warning.main;

        return (
          <Tooltip title={`Hosts: ${configPercent}% configurado (${configCount} de ${configTotal} ${configTotal === 1 ? "serviço" : "serviços"})`} arrow placement="top">
            <Box
              onClick={(e) => {
                e.stopPropagation();
                localStorage.setItem("selectedClient", JSON.stringify(params.row));
                setSelectedCliente(params.row);
                navigate(`/interno/home/perfil/config/${params.row.id}`);
              }}
              sx={{
                cursor: "pointer",
                width: 22,
                height: 22,
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: alpha(configIconColor, 0.12),
                border: `1px solid ${alpha(configIconColor, 0.28)}`,
                color: configIconColor,
                "&:hover": {
                  bgcolor: alpha(configIconColor, 0.22),
                },
              }}
            >
              <DnsRounded sx={{ fontSize: 16 }} />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "fillingStatusCircuit",
      headerName: "Circuitos",
      flex: 0.4,
      sortable: false,
      valueGetter: (value, row) => {
        const clientStatus = getClientFillingStatus(row);
        return clientStatus?.circuitPercent || 0;
      },
      renderCell: (params) => {
        // Status de preenchimento não se aplica a grupos econômicos
        if (params?.row?.isGrupoEconomico) return "—";

        const clientStatus = getClientFillingStatus(params.row);

        const circuitCount = clientStatus?.circuitFilledCount || 0;
        const circuitPercent = clientStatus?.circuitPercent || 0;
        const circuitTotal = clientStatus.totalServicos || circuitCount;
        
        let circuitIconColor = theme.palette.error.main;
        if (circuitPercent === 100) circuitIconColor = theme.palette.success.main;
        else if (circuitPercent >= 50) circuitIconColor = theme.palette.info.main;
        else if (circuitPercent > 0) circuitIconColor = theme.palette.warning.main;

        return (
          <Tooltip title={`Circuitos: ${circuitPercent}% preenchido (${circuitCount} de ${circuitTotal} ${circuitTotal === 1 ? "serviço" : "serviços"})`} arrow placement="top">
            <Box
              onClick={(e) => {
                e.stopPropagation();
                localStorage.setItem("selectedClient", JSON.stringify(params.row));
                setSelectedCliente(params.row);
                navigate(`/interno/home/perfil/circuito/${params.row.id}`);
              }}
              sx={{
                cursor: "pointer",
                width: 22,
                height: 22,
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: alpha(circuitIconColor, 0.12),
                border: `1px solid ${alpha(circuitIconColor, 0.28)}`,
                color: circuitIconColor,
              
              }}
            >
              <RouterRounded sx={{ fontSize: 16 }} />
            </Box>
          </Tooltip>
        );
      },
    },

    {
      field: "actions",
      headerName: "Opções",
      sortable: false,
      flex: 0.3,

      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation();

          const thisRow = params.row;
          setSelectedRow(thisRow);
          setAnchorEl(e.currentTarget);
        };

        //
        return (
          <Box key={params.id}>
            <Tooltip title={"Ações"} id="basic-button" onClick={onClick}>
              <IconButton size="small" sx={{ padding: 0 }}>
                <SettingsOutlined
                  sx={{
                    color:
                      theme.palette.mode === "dark"
                        ? theme.palette.white.main
                        : "grey",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  const totalSystemServices = totais.totalServicos;
  const totalSystemHostsFilled = totais.totalHostsConfig;
  const totalSystemCircuitsFilled = totais.totalCircuitosFilled;
  
  const globalHostPercent = totalSystemServices > 0 ? Math.round((totalSystemHostsFilled / totalSystemServices) * 100) : 0;
  const globalCircuitPercent = totalSystemServices > 0 ? Math.round((totalSystemCircuitsFilled / totalSystemServices) * 100) : 0;
  
  let globalHostColor = theme.palette.error.main;
  if (globalHostPercent === 100 && totalSystemServices > 0) globalHostColor = theme.palette.success.main;
  else if (globalHostPercent >= 50) globalHostColor = theme.palette.info.main;
  else if (globalHostPercent > 0) globalHostColor = theme.palette.warning.main;

  let globalCircuitColor = theme.palette.error.main;
  if (globalCircuitPercent === 100 && totalSystemServices > 0) globalCircuitColor = theme.palette.success.main;
  else if (globalCircuitPercent >= 50) globalCircuitColor = theme.palette.info.main;
  else if (globalCircuitPercent > 0) globalCircuitColor = theme.palette.warning.main;

  return (
    <Box sx={styles.container}>
      <Paper
        sx={styles.paperDatagrid}
        elevation={theme.palette.mode == "dark" ? 0 : 3}
      >
        <Typography sx={styles.title}>Clientes</Typography>

        <Paper elevation={0} sx={styles.paperSupContainer}>
          {windowWith < 640 ? (
            <Box>
              <List sx={styles.listContentMobile}>
                <Divider component="li" />
                {linhas.map((row, index) => (
                    <Box key={index}>
                      <ListItem sx={styles.listItens}>
                        <Box sx={styles.containerListItens}>
                          <Box sx={styles.containerNameRazaoSocial}>
                            <Typography
                              sx={styles.nomeFantasia}
                              variant="mySubtitle"
                            >
                              {row?.nome || ""}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              sx={{ opacity: "0.8" }}
                              variant="caption"
                            >
                              E-mail:
                            </Typography>
                            <Typography variant="caption">
                              {row?.email
                                ? row?.email
                                : row?.ClientesCadastro?.email || ""}
                            </Typography>
                          </Box>
                          <Chip
                            label={row?.status === 0 ? "Ativo" : "Desativado"}
                            size="medium"
                            sx={{
                              ...styles.chip,
                              bgcolor:
                                row?.status === 0
                                  ? "chip.main.completed"
                                  : "chip.main.pending",
                              fontWeight: 600,
                            }}
                          />
                          {!row?.isGrupoEconomico && (
                          <Box sx={{ mt: 1, display: "flex", gap: 1, flexDirection: "row", alignItems: "center", width: "100%" }}>
                            {(() => {
                              const clientStatus = getClientFillingStatus(row);
                              const count = clientStatus?.configFilledCount || 0;
                              const percent = clientStatus?.configPercent || 0;
                              const total = clientStatus.totalServicos || count;
                              
                              let iconColor = theme.palette.error.main;
                              if (percent === 100) iconColor = theme.palette.success.main;
                              else if (percent >= 50) iconColor = theme.palette.info.main;
                              else if (percent > 0) iconColor = theme.palette.warning.main;

                              return (
                                <Tooltip title={`Hosts Zabbix: ${percent}% configurado (${count} de ${total} ${total === 1 ? "serviço" : "serviços"})`} arrow placement="top">
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="caption" sx={{ opacity: 0.8, fontWeight: 600 }}>Hosts Zabbix:</Typography>
                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        localStorage.setItem("selectedClient", JSON.stringify(row));
                                        setSelectedCliente(row);
                                        navigate(`/interno/home/perfil/config/${row.id}`);
                                      }}
                                      sx={{
                                        cursor: "pointer",
                                        width: 26,
                                        height: 26,
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bgcolor: alpha(iconColor, 0.12),
                                        border: `1px solid ${alpha(iconColor, 0.28)}`,
                                        color: iconColor,
                                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                                        "&:hover": {
                                          bgcolor: alpha(iconColor, 0.22),
                                          transform: "scale(1.06)",
                                        },
                                      }}
                                    >
                                      <DnsRounded sx={{ fontSize: 16 }} />
                                    </Box>
                                  </Box>
                                </Tooltip>
                              );
                            })()}

                            {(() => {
                              const clientStatus = getClientFillingStatus(row);
                              const count = clientStatus?.circuitFilledCount || 0;
                              const percent = clientStatus?.circuitPercent || 0;
                              const total = clientStatus.totalServicos || count;
                              
                              let iconColor = theme.palette.error.main;
                              if (percent === 100) iconColor = theme.palette.success.main;
                              else if (percent >= 50) iconColor = theme.palette.info.main;
                              else if (percent > 0) iconColor = theme.palette.warning.main;

                              return (
                                <Tooltip title={`Circuitos de Acesso: ${percent}% preenchido (${count} de ${total} ${total === 1 ? "serviço" : "serviços"})`} arrow placement="top">
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
                                    <Typography variant="caption" sx={{ opacity: 0.8, fontWeight: 600 }}>Circuito:</Typography>
                                    <Box
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        localStorage.setItem("selectedClient", JSON.stringify(row));
                                        setSelectedCliente(row);
                                        navigate(`/interno/home/perfil/circuito/${row.id}`);
                                      }}
                                      sx={{
                                        cursor: "pointer",
                                        width: 26,
                                        height: 26,
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        bgcolor: alpha(iconColor, 0.12),
                                        border: `1px solid ${alpha(iconColor, 0.28)}`,
                                        color: iconColor,
                                        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                                        "&:hover": {
                                          bgcolor: alpha(iconColor, 0.22),
                                          transform: "scale(1.06)",
                                        },
                                      }}
                                    >
                                      <RouterRounded sx={{ fontSize: 16 }} />
                                    </Box>
                                  </Box>
                                </Tooltip>
                              );
                            })()}
                          </Box>
                          )}
                        </Box>

                        <IconButton
                          sx={styles.iconButton}
                          onClick={(e) => {
                            setSelectedRow(row);
                            handleClick(e);
                          }}
                        >
                          <MoreVert />
                        </IconButton>
                      </ListItem>
                      <Divider component="li" />
                    </Box>
                  ))}
              </List>
              <Box sx={{ display: "flex", marginTop: "10px" }}>
                <Stack sx={{ margin: "auto" }} spacing={2}>
                  <Pagination
                    count={Math.ceil(total / linhasPorPagina)}
                    page={pagina + 1}
                    onChange={(e, p) => setPagina(p - 1)}
                  />
                </Stack>
              </Box>
            </Box>
          ) : (
            <Paper
              elevation={0}
              sx={{ minHeight: "100px", p: 2, borderRadius: "16px" }}
            >
              <Box sx={styles.searchAndCardsContainer}>
                <TextField
                  label="Buscar cliente"
                  variant="outlined"
                  autoComplete="off"
                  placeholder="Nome, Email, Asn, etc..."
                  value={buscarUsuario}
                  size="small"
                  onChange={(event) => {
                    setBuscarUsuario(event?.target?.value?.trimStart());
                  }}
                  sx={styles.searchField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: buscarUsuario ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setBuscarUsuario("")}
                          edge="end"
                        >
                          <Clear size={"small"} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
                
                <Box sx={styles.globalCardContainer}>
                  <Box
                    sx={{
                      ...styles.globalCard,
                      bgcolor: alpha(globalHostColor, 0.08),
                      border: `1px solid ${alpha(globalHostColor, 0.35)}`,
                    }}
                  >
                    <Box
                      sx={{
                        ...styles.globalCardIconBox,
                        bgcolor: alpha(globalHostColor, 0.15),
                        color: globalHostColor,
                      }}
                    >
                      <DnsRounded fontSize="small" />
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={styles.globalCardTitle}>
                        Hosts Gerais
                      </Typography>
                      <Box sx={styles.globalCardValueBox}>
                        <Typography variant="body2" sx={styles.globalCardPercent}>
                          {globalHostPercent}%
                        </Typography>
                        <Typography variant="caption" sx={styles.globalCardCount}>
                          ({totalSystemHostsFilled}/{totalSystemServices})
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      ...styles.globalCard,
                      bgcolor: alpha(globalCircuitColor, 0.08),
                      border: `1px solid ${alpha(globalCircuitColor, 0.35)}`,
                    }}
                  >
                    <Box
                      sx={{
                        ...styles.globalCardIconBox,
                        bgcolor: alpha(globalCircuitColor, 0.15),
                        color: globalCircuitColor,
                      }}
                    >
                      <RouterRounded fontSize="small" />
                    </Box>
                    <Box>
                      <Typography variant="caption" sx={styles.globalCardTitle}>
                        Circuitos Gerais
                      </Typography>
                      <Box sx={styles.globalCardValueBox}>
                        <Typography variant="body2" sx={styles.globalCardPercent}>
                          {globalCircuitPercent}%
                        </Typography>
                        <Typography variant="caption" sx={styles.globalCardCount}>
                          ({totalSystemCircuitsFilled}/{totalSystemServices})
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {selectedClientIds.length > 0 && (
                <Box sx={styles.bulkActionBar}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box 
                      sx={{ 
                        backgroundColor: 'primary.main', 
                        color: 'primary.contrastText', 
                        borderRadius: '50%', 
                        width: 24, 
                        height: 24, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '0.9rem',
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                      }}
                    >
                      {selectedClientIds.length}
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
                      clientes selecionados
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    size="medium"
                    onClick={(e) => setBulkTagMenuAnchorEl(e.currentTarget)}
                   
                    sx={{
                      borderRadius: "10px",
                      textTransform: "none",
                      fontWeight: "bold",
                      
                    }}
                  >
                    Atribuir Tag 
                  </Button>
                </Box>
              )}
              <DatagridComponent
                rows={linhas}
                columns={columns}
                loading={carregando}
                isPagination
                options={{
                  autoHeight: true,
                  checkboxSelection: true,
                  disableRowSelectionOnClick: true,
                  keepNonExistentRowsSelected: true,
                  onRowSelectionModelChange: (newSelection) => {
                    setSelectedClientIds(newSelection);
                  },
                  rowSelectionModel: selectedClientIds,
                  getRowHeight: () => "auto",
                  getEstimatedRowHeight: () => 50,
                  paginationMode: "server",
                  rowCount: total,
                  paginationModel: { page: pagina, pageSize: linhasPorPagina },
                  onPaginationModelChange: (modelo) => {
                    if (modelo.pageSize !== linhasPorPagina) {
                      setLinhasPorPagina(modelo.pageSize);
                      setPagina(0);
                    } else {
                      setPagina(modelo.page);
                    }
                  },
                  sortingMode: "server",
                  sortModel: modeloOrdenacao,
                  onSortModelChange: (modelo) => {
                    setOrdenacao({
                      coluna: modelo[0]?.field || null,
                      direcao: modelo[0]?.sort || "asc",
                    });
                    setPagina(0);
                  },
                }}
                sxDatagrid={{
                  "& .MuiDataGrid-row": {
                    maxHeight: "none !important",
                  },
                  "& .MuiDataGrid-cell": {
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "normal",
                  },
                }}
              />
            </Paper>
          )}
        </Paper>
      </Paper>
      <ModalEditCadastro
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        handleUpdatedClient={handleUpdatedClient}
        setSnackbar={setSnackbar}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={deleteLoad}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          handleApiDeleteClientes(selectedRow?.id);
        }}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDesativacao}
        load={deleteLoad}
        setOpenConfirmacao={setOPenDesativacao}
        execute={() => {
          updateStatusCliente(selectedRow?.id, statusCliente);
        }}
        title={"Atenção"}
        severity={"warning"}
        headerText={"Deseja realmente desativar o cadastro?"}
        contentText={desativarBody}
        confirmText={confirmDesativar}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            const clientStorage = {
              interfaceId: "",
              clienteId: selectedRow.id,
              hostId: "",
              selectTime: 5,
              initialDate: "",
              finalDate: "",
            };

            localStorage.setItem("filterData", JSON.stringify(clientStorage));
            setAnchorEl(null);
            navigate(
              `/interno/home/perfil/servicos/${selectedRow.id}`,
              // , {state: { selectedRow },}
            );
          }}
        >
          <Person sx={{ marginRight: "16px" }}></Person> Perfil
        </MenuItem>

        {/* Grupos econômicos não podem ser desativados/excluídos por aqui */}
        {!selectedRow?.isGrupoEconomico &&
          (selectedRow?.status === 0 ? (
            <MenuItem
              onClick={() => {
                setOPenDesativacao(true);
                setStatusCLiente(1);
                setAnchorEl(null);
              }}
            >
              <NotInterestedOutlined sx={{ marginRight: "16px" }} />
              Desativar
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                setAnchorEl(null);
                updateStatusCliente(selectedRow?.id, 0);
              }}
            >
              <NotInterestedOutlined sx={{ marginRight: "16px" }} />
              Ativar
            </MenuItem>
          ))}

        {!selectedRow?.isGrupoEconomico && (
          <MenuItem
            onClick={() => {
              setOpenDeleteModal(true);
              setAnchorEl(null);
            }}
            sx={{ color: "error.main" }}
          >
            <Delete sx={{ marginRight: "16px" }}></Delete> Excluir
          </MenuItem>
        )}
      </Menu>

      <Menu
        open={openNotificacao}
        anchorEl={anchorNotificacao}
        placement={"bottom-end"}
        onClose={handleClose}
      >
        {Array.isArray(pendentes) &&
          pendentes?.map((pendente, index) => (
            <MenuItem
              sx={styles.menuItensMobile}
              onClick={(e) => {
                e.stopPropagation();
                navigate(pendente?.link);
              }}
              key={`${pendente?.id}-${index}`}
            >
              <Box sx={styles.containerMenuMobile}>
                {pendente?.icon}
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ marginRight: "10px" }}
                />
                <Typography variant="caption" sx={{ width: "100%" }}>
                  {pendente?.message}
                </Typography>
              </Box>
              <OpenInNewOutlined fontSize="small" sx={{ marginLeft: "10px" }} />
            </MenuItem>
          ))}
      </Menu>
      <TagsMenu
        anchorEl={tagsMenuAnchorEl}
        open={Boolean(tagsMenuAnchorEl)}
        onClose={() => setTagsMenuAnchorEl(null)}
        cliente={selectedClienteForTags}
        onSaved={handleTagsSaved}
        onSaving={(isSaving) => setLoadingTagClienteId(isSaving ? selectedClienteForTags?.id : null)}
        setSnackbar={setSnackbar}
        styles={styles}
        theme={theme}
      />
      <Menu
        anchorEl={bulkTagMenuAnchorEl}
        open={Boolean(bulkTagMenuAnchorEl)}
        onClose={() => setBulkTagMenuAnchorEl(null)}
      >
        <Box sx={{ p: 1, minWidth: 200 }}>
          <Typography variant="caption" sx={{ fontWeight: "bold", mb: 1, display: "block" }}>
            Selecione uma tag para atribuir
          </Typography>
          <Divider sx={{ mb: 1 }} />
          {availableTags.map(tag => (
            <MenuItem key={tag.id} onClick={() => handleBulkTagAssign(tag)}>
              <Chip
                size="small"
                label={tag.tagName}
                sx={{
                  bgcolor: tag.color,
                  color: "#fff",
                  fontWeight: "bold",
                  mr: 1
                }}
              />
            </MenuItem>
          ))}
          {availableTags.length === 0 && (
            <Typography variant="caption" color="textSecondary">
              Nenhuma tag disponível.
            </Typography>
          )}
        </Box>
      </Menu>
    </Box>
  );
}
